export default "__VITE_IMAGE_ASSET__ffe927d0__";